// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-container {
  padding: 24px;
  max-width: 1600px;
  margin: 0 auto;
}

.statistics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.statistics-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.summary-card h4 {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: normal;
}

.summary-value {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.summary-value.primary {
  color: #1976d2;
}

.summary-value.success {
  color: #4caf50;
}

.summary-value.warning {
  color: #ff9800;
}

.summary-value.info {
  color: #00bcd4;
}

.statistics-tabs {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-content {
  padding: 24px;
}

.chart-container {
  margin-bottom: 32px;
}

.chart-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  color: #333;
}

.data-grid-container {
  height: 600px;
  width: 100%;
}

.question-stats-table {
  margin-top: 16px;
  margin-bottom: 32px;
}

.question-stats-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #333;
}

.no-data-message {
  text-align: center;
  padding: 48px;
  color: #666;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* DataGrid 커스터마이징 */
.MuiDataGrid-root {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.MuiDataGrid-columnHeaders {
  background-color: #f5f5f5;
  font-weight: 600;
}

.MuiDataGrid-cell {
  border-bottom: 1px solid #f0f0f0;
}

.MuiDataGrid-row:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .statistics-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .statistics-filters {
    width: 100%;
    flex-direction: column;
  }

  .summary-cards {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Statistics.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".statistics-container {\n  padding: 24px;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n.statistics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.statistics-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.summary-card {\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.summary-card h4 {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 8px;\n  font-weight: normal;\n}\n\n.summary-value {\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n  margin: 0;\n}\n\n.summary-value.primary {\n  color: #1976d2;\n}\n\n.summary-value.success {\n  color: #4caf50;\n}\n\n.summary-value.warning {\n  color: #ff9800;\n}\n\n.summary-value.info {\n  color: #00bcd4;\n}\n\n.statistics-tabs {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tab-content {\n  padding: 24px;\n}\n\n.chart-container {\n  margin-bottom: 32px;\n}\n\n.chart-title {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 16px;\n  color: #333;\n}\n\n.data-grid-container {\n  height: 600px;\n  width: 100%;\n}\n\n.question-stats-table {\n  margin-top: 16px;\n  margin-bottom: 32px;\n}\n\n.question-stats-title {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.no-data-message {\n  text-align: center;\n  padding: 48px;\n  color: #666;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* DataGrid 커스터마이징 */\n.MuiDataGrid-root {\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.MuiDataGrid-columnHeaders {\n  background-color: #f5f5f5;\n  font-weight: 600;\n}\n\n.MuiDataGrid-cell {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.MuiDataGrid-row:hover {\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .statistics-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .statistics-filters {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .summary-cards {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
